import React from "react";
import { useNavigate } from "react-router-dom";
import './Styles.css';

const SubscriptionConfirmed = () => {
  const navigate = useNavigate();

  const handleLoginRedirect = () => {
    navigate("/login");
  };

  return (
    <div className="app-container">
      <h1>Subscription Confirmed</h1>
      <p>Your subscription is now active. You can log in to start using the platform.</p>
      <button onClick={handleLoginRedirect}>Go to Login</button>
    </div>
  );
};

export default SubscriptionConfirmed;
